<template>
  <div class="wrap">
    <div class="my_page">
      <div class="key_visual addImg out">
        <!-- <div class="container">
          <p>회원 탈퇴</p>
        </div> -->
      </div>

      <div class="my_page_content">
        <div class="container">
          <div class="form_area">
            <form id="my_page_pw_change" @submit.prevent="sendData()">
              <div class="my_page_confirm">
                <h3>회원 탈퇴하기</h3>
                <p class="text_left">
                  회원 탈퇴를 진행하기 위해 비밀번호를 한 번 더 확인합니다.
                </p>
                <input
                  id="user_pw"
                  v-model="userPW"
                  type="password"
                  class="input"
                  name=""
                  placeholder="비밀번호를 입력해주세요."
                />
              </div>
              <div class="btn_area">
                <input
                  type="submit"
                  class="btn_orange"
                  value="확인"
                  @click="sendData()"
                />
              </div>
            </form>
          </div>
          <div class="Modals">
            <ModalAlert
              :alertMsg="errMsg"
              :isOpen="errStatus"
              @update:isOpen="updateStatus"
            ></ModalAlert>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
// import { mypagePWChange, myapgePWChk } from '../api/mypage'
import { useRouter } from 'vue-router'
// import { useCookies } from 'vue3-cookies'
import { myapgePWChk } from '../api/withdrawal'
import ModalAlert from '../components/ModalAlert.vue'

export default {
  name: 'WithdrawalViews',
  components: {
    ModalAlert,
  },
  setup() {
    const router = useRouter()
    // const { cookies } = useCookies()

    const errMsg = ref('')
    const errStatus = ref(false)

    const userPW = ref('')
    const sendData = async () => {
      try {
        // console.log("비밀번호 체크");
        const checkPW = await myapgePWChk(userPW.value)
        // console.log(checkPW);
        if (checkPW.code === 'MB41003400') {
          // // console.log("비밀번호가 일치하지 않습니다.");
          errStatus.value = true
          errMsg.value =
            '비밀번호가 올바르지 않습니다.<br>입력하신 비밀번호를 다시 확인해주세요.'
        } else if (checkPW.code === 'MB41002400') {
          // // console.log("비밀번호가 입력되지 않았습니다.");
          errStatus.value = true
          errMsg.value = '비밀번호가 입력되지 않았습니다.'
        } else if (checkPW.code === 'MB41000200') {
          router.push({ name: 'WithdrawalCompleteViews' })
        }
      } catch (err) {
        // console.log(err);
      }
    }

    const updateStatus = () => {
      errStatus.value = false
    }

    onMounted(() => {
      // console.log(cookies.get('access_token'))
    })

    return {
      errMsg,
      errStatus,

      userPW,

      sendData,
      updateStatus,
    }
  },
}
</script>
